var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ContainerScrolling',{staticClass:"communities-dashboard"},[_c('CommunitiesBanner',{attrs:{"banner-title":_vm.pageName,"banner-text":_vm.bannerText}}),_vm._v(" "),_c('LayoutGutters',{staticClass:"mt-6"},[_c('SelectedCommunities',{attrs:{"communities":_vm.communities}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }